import { Button, Col, Form, Row, Stack } from "react-bootstrap";
import EstadoMotivo from "./EstadoMotivo";

function MotivoAdministrador({
  motivo,
  motivoEditando,
  nombreEditado,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onNombreEditadoChange,
  onToggleActivo,
}) {
  return (
    <Row
      className="m-0 px-2 py-3 border rounded align-items-center h-100 w-100 flex-wrap"
      style={{
        backgroundColor: motivo.activo ? "white" : "var(--color-inactive)",
      }}
    >
      <Col
        className="d-flex align-items-center flex-grow-1 m-0 h-100"
        style={{ minWidth: 0 }}
      >
        {motivoEditando === motivo.id ? (
          <Form.Control
            type="text"
            value={nombreEditado}
            onChange={(e) => onNombreEditadoChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSaveEdit(motivo.id);
              }
              if (e.key === "Escape") {
                onCancelEdit();
              }
            }}
            autoFocus
            style={{ maxWidth: "300px" }}
          />
        ) : (
          <span
            className={`fw-semibold ${!motivo.activo ? "text-muted" : ""}`}
            style={{
              width: "100%",
              whiteSpace: "normal",
              overflowWrap: "anywhere",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center", // ⬅⬅ CENTRA EL TEXTO VERTICALMENTE
            }}
          >
            {motivo.nombre}
          </span>
        )}
      </Col>

      <Col
        xs="auto"
        className="m-0 d-flex align-items-center"
        style={{ minWidth: 0 }}
      >
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center">
            <EstadoMotivo estado={motivo.activo} />
          </div>

          <div className="d-flex align-items-center">
            {motivoEditando === motivo.id ? (
              <Stack
                direction="horizontal"
                gap={1}
                className="align-items-center"
              >
                <Button
                  size="sm"
                  variant="success"
                  onClick={() => onSaveEdit(motivo.id)}
                >
                  <i className="bi bi-check-lg"></i>
                </Button>

                <Button size="sm" variant="secondary" onClick={onCancelEdit}>
                  <i className="bi bi-x-lg"></i>
                </Button>
              </Stack>
            ) : (
              <Stack
                direction="horizontal"
                gap={1}
                className="align-items-center"
              >
                <Button
                  size="sm"
                  className="btn-primary-blue"
                  onClick={() => onStartEdit(motivo)}
                  title="Editar nombre"
                >
                  <i className="bi bi-pencil"></i>
                </Button>

                <Button
                  size="sm"
                  className={
                    motivo.activo ? "btn-outline-accent" : "btn-accent"
                  }
                  onClick={() => onToggleActivo(motivo)}
                  title={motivo.activo ? "Desactivar" : "Activar"}
                >
                  <i
                    className={`bi bi-${motivo.activo ? "eye-slash" : "eye"}`}
                  />
                </Button>
              </Stack>
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default MotivoAdministrador;
